import actionTypes from '../actionTypes';

export const getProfile = () => ({
  type: actionTypes.PROFILE_GET_REQUEST,
});

export const updateProfile = (profile) => ({
  type: actionTypes.PROFILE_UPDATE_REQUEST,
  profile,
});

export const verifyPhone = (data) => ({
  type: actionTypes.PHONE_VERIFY_REQUEST,
  data,
});

export const checkPhoneVerify = (data) => ({
  type: actionTypes.PHONE_VERIFY_CHECK_REQUEST,
  data,
});

export const changePassword = (data) => ({
  type: actionTypes.PASSWORD_CHANGE_REQUEST,
  data,
});

export const getMarketingContent = (userId) => ({
  type: actionTypes.GET_MARKETING_CONTENT_REQUEST,
  userId,
});

export const createMarketingContent = (data) => ({
  type: actionTypes.CREATE_MARKETING_CONTENT_REQUEST,
  data,
});

export const updateMarketingContent = (data) => ({
  type: actionTypes.UPDATE_MARKETING_CONTENT_REQUEST,
  data,
});

export const fixAgreementInviteIssue = (data) => ({
  type: actionTypes.FIX_AGREEMENT_INVITE_ISSUE_REQUEST,
  data,
});



// WEBPACK FOOTER //
// src/redux/actions/profile.js